import * as a1lib from "alt1";
import { ImgRefData } from "alt1";
import * as fsimport from "fs";
export function inrange(x, a, b) {
    return x >= a && x < b;
}
// awkward workaround to deal with fs not being available CEF
export const fs = fsimport?.promises;
//weird generics on fallback to force ts to use the stricter type provided by map
export function getOrInsert(map, key, fallback) {
    let val = map.get(key);
    if (val === undefined) {
        val = fallback();
        map.set(key, val);
    }
    return val;
}
export function bufferToBase64(buf) {
    let binary = "";
    let len = buf.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(buf[i]);
    }
    return btoa(binary);
}
export function flipImagedata(buf) {
    let stride = buf.width * 4;
    for (let y = 0; y < buf.height / 2; y++) {
        let topindex = y * stride;
        let botindex = (buf.height - 1 - y) * stride;
        let cpy = buf.data.slice(topindex, topindex + stride);
        buf.data.copyWithin(topindex, botindex, botindex + stride);
        buf.data.set(cpy, botindex);
    }
}
export function copyStylesToFrame(from, to) {
    var arrStyleSheets = from.getElementsByTagName("style");
    for (var i = 0; i < arrStyleSheets.length; i++) {
        to.head.appendChild(arrStyleSheets[i].cloneNode(true));
    }
}
export async function timedRetryCb(timelimit, name = "unknown", cb) {
    var t = Date.now();
    while (true) {
        let r = await cb();
        if (r) {
            return r;
        }
        if (Date.now() - t > timelimit) {
            throw new Error(`Timedretry "${name}" failed to complete in ${timelimit}ms`);
        }
        await delay(100);
    }
}
export async function captureFullRsAsync() {
    let img = await a1lib.captureAsync(0, 0, alt1.rsWidth, alt1.rsHeight);
    return new ImgRefData(img, 0, 0);
}
export function delay(t) {
    return new Promise(done => setTimeout(done, t));
}
export var TextEncoderPolyfill = (typeof TextEncoder != "undefined" ? TextEncoder : require("util").TextEncoder);
export var TextDecoderPolyfill = (typeof TextDecoder != "undefined" ? TextDecoder : require("util").TextDecoder);
/**
 * used to get an array with enum typing
 */
export function arrayEnum(v) {
    return v;
}
export function filedownload(filename, url) {
    var element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
export function newDragHandler(startevent, movefunc, mindist = 0) {
    var locked = mindist != 0;
    var mouseloc;
    //type juggling because firefox doesnt know what touchevent is
    if (window.TouchEvent && startevent instanceof TouchEvent) {
        startevent = startevent.touches[0];
    }
    var mousedownevent = startevent;
    var clientdx = mousedownevent.clientX - mousedownevent.screenX;
    var clientdy = mousedownevent.clientY - mousedownevent.screenY;
    //TODO screenX approach breaks when zoomed or clientx is required
    var x = mousedownevent.screenX + clientdx;
    var y = mousedownevent.screenY + clientdy;
    var init = function () { mouseloc = { x: x, y: y, dx: 0, dy: 0, sx: x, sy: y, end: false, start: true }; };
    init();
    var moved = function (e, end) {
        var x = e.screenX + clientdx;
        var y = e.screenY + clientdy;
        var dx = x - mouseloc.x;
        var dy = y - mouseloc.y;
        if (locked && Math.abs(dx) + Math.abs(dy) >= mindist) {
            locked = false;
        }
        if (!locked) {
            mouseloc.end = end;
            mouseloc.dx = dx;
            mouseloc.dy = dy;
            mouseloc.x = x;
            mouseloc.y = y;
            movefunc && movefunc(mouseloc, end);
            mouseloc.start = false;
        }
    };
    var mousemove = function (e) {
        if (e.touches) {
            e = e.touches[0];
        }
        moved(e, false);
    };
    var mouseup = function (e) {
        if (e.touches) {
            e = e.touches[0];
        }
        if (e) {
            moved(e, true);
        }
        window.removeEventListener("mousemove", mousemove);
        window.removeEventListener("mouseup", mouseup);
        window.removeEventListener("touchmove", mousemove);
        window.removeEventListener("touchend", mouseup);
    };
    window.addEventListener("mousemove", mousemove, { passive: true });
    window.addEventListener("mouseup", mouseup);
    window.addEventListener("touchmove", mousemove, { passive: true });
    window.addEventListener("touchend", mouseup);
}
export class TypedEmitter {
    constructor() {
        this.listeners = {};
    }
    on(event, listener) {
        let listeners = this.listeners[event] ?? (this.listeners[event] = new Set());
        listeners.add(listener);
        this.listenersChanged(event, listeners);
    }
    once(event, listener) {
        let listeners = this.listeners[event] ?? (this.listeners[event] = new Set());
        let oncer = (v) => {
            listeners.delete(oncer);
            listener(v);
        };
        listeners.add(oncer);
        this.listenersChanged(event, listeners);
    }
    off(event, listener) {
        let listeners = this.listeners[event] ?? (this.listeners[event] = new Set());
        listeners.delete(listener);
        this.listenersChanged(event, listeners);
    }
    emit(event, value) {
        let listeners = this.listeners[event] ?? (this.listeners[event] = new Set());
        listeners.forEach(cb => cb(value));
    }
    listenersChanged(event, listeners) {
        //can be overwritten
    }
}
export function mat3ToCtxArgs(mat /* THREE.Matrix3 */) {
    if (mat.elements[2] != 0 || mat.elements[5] != 0 || mat.elements[8] != 1) {
        console.log("matrix3 is not an 2d transform");
    }
    return [
        mat.elements[0], mat.elements[1],
        mat.elements[3], mat.elements[4],
        mat.elements[6], mat.elements[7]
    ];
}
